<script lang="ts" setup>
import img1 from '~/assets/image/index/guide/guide_01.svg?url';
import img2 from '~/assets/image/index/guide/guide_02.svg?url';
import img3 from '~/assets/image/index/guide/guide_03.svg?url';
import img4 from '~/assets/image/index/guide/guide_04.svg?url';
import ModuleTitle from './ModuleTitle.vue';
import UserGuideEntryItem from './UserGuideEntryItem.vue';

const list = [
  {
    id: 1,
    title: 'OJ简介',
    tip: '快速了解什么是OJ',
    part: '',
    img: img1,
    event: { item_index: 1 },
  },
  {
    id: 2,
    title: 'OJ使用',
    tip: '快速使用OJ刷题',
    part: '#part1',
    img: img2,
    event: { item_index: 2 },
  },
  {
    id: 3,
    title: '赛事指引',
    tip: '备赛 有哪些赛制',
    part: '#part2',
    img: img3,
    event: { item_index: 3 },
  },
  {
    id: 4,
    title: '赛事资讯',
    tip: '官方赛事最新消息',
    part: '#part3',
    img: img4,
    event: { item_index: 4 },
  },
];
</script>

<template>
  <div class="rounded border border-lightblack bg-white p-3">
    <ModuleTitle tip="4步带你学" class="mb-[14px] mt-[2px]">
      <img src="~/assets/image/index/title/qsss.svg" alt="轻松上手OJ" />
    </ModuleTitle>
    <div class="flex items-center justify-between gap-3">
      <UserGuideEntryItem
        v-for="item in list"
        :key="item.id"
        v-track:newoj_homepage_DiamondThrone_show="item.event"
        v-track:newoj_homepage_DiamondThrone_click.click="item.event"
        :title="item.title"
        :tip="item.tip"
        :part="item.part"
      >
        <img class="h-[34px]" :src="item.img" alt="icon" />
      </UserGuideEntryItem>
    </div>
  </div>
</template>
